<main role="main">
    <app-banner1-component />
    <app-tier-features-component />
    <app-publish-component />
    <app-banner2-component />
    <app-hippacomponent />
    <app-support-component />
    <app-faqcomponent />
</main>